export default __webpack_public_path__ + "static/media/Apartament Codruta_18-min.629436d0.jpg";